import MultiSignActivitiesModal from './multi-sign-activities-modal-container'
import MultiSignActivitiesModalContext from './multi-sign-activities-modal-context'

export { MultiSignActivitiesModalContext }
export default MultiSignActivitiesModal
